/**
 * Created by calhosh on 9/3/2024
 */
import React from 'react';
import _ from 'lodash';
import {documentTypes, EngagementStatus, reviewNoteRoutes} from '../../../util/uiconstants';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {
	IconoirHome,
	IconoirGroup,
	IconoirMap,
	IconoirReportColumns,
	IconoirPage,
	IconoirPageEdit
} from '@ey-xd/motif-icon';
import env from '../../../util/env';
import {labels} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import MotifDropdown from '@ey/motif-react-wrapper/Dropdown';
import MotifTextLink from '../BaseComponentWrappers/MotifTextLink';
import {
	IconoirCustomSmartAutomationProduct,
	IconoirCustomTaskList,
	IconoirCustomServiceGateway
} from '@ey/motif-react-wrapper/assets/icons/custom';

export function MenuIconOptions({
	engagement,
	configurations,
	formData,
	engagements,
	displayLanguage,
	isAutomationHubEnabled,
	gateWayOptionsOpen,
	setGateWayOptionsOpen,
	selectedIcon,
	setSelectedIcon,
	quickLinks
}) {
	let menuOptions = [];

	let engagementArchived =
		engagement.engagementStatusId === EngagementStatus.Archived || engagement.isProfileComplete === false;
	let engagementClosed = formData && formData.documentTypeId === documentTypes.ACCOUNT_CONCLUSION;

	function getSDMFeatureRestricted(
		restrictedCountryIds,
		validServiceLines,
		countryId,
		engServiceLineId,
		engSubServiceLineId
	) {
		if (!(countryId > 0)) {
			return true;
		}

		if (_.some(restrictedCountryIds, (id) => id === -1 || id === countryId)) {
			/*if -1 value is available in list then disable at LDC level*/
			return true;
		}

		/*If serviceline and subserviceline combination matched then it should not be restricted.*/
		return !_.some(
			validServiceLines,
			({serviceLineId, subServiceLineId}) =>
				serviceLineId === engServiceLineId && subServiceLineId === engSubServiceLineId
		);
	}

	const getServiceGatewayAndAutomation = () => {
		return (
			<MotifDropdown
				open={gateWayOptionsOpen}
				handleOnClose={() => {
					setGateWayOptionsOpen(false);
					setSelectedIcon(undefined);
				}}
				//closeOnOutsideClick={false}
				className="GateWayOptionsDropdown"
				trigger={
					<MotifButton
						key="serviceGatewayAutomation"
						aria-label="Click to go to service gateway and automation"
						type="button"
						variant="ghost"
						size="medium"
						title={labels.eyserviceGatewayAutomation}
						isSelected={selectedIcon === 'serviceGatewayAutomation'}
						className="motif-button-icon-only"
					>
						<MotifIcon
							onClick={() => {
								setGateWayOptionsOpen(!gateWayOptionsOpen);
								setSelectedIcon('serviceGatewayAutomation');
							}}
							src={IconoirCustomSmartAutomationProduct}
							size="24"
							title={labels.eyserviceGatewayAutomation}
						/>
					</MotifButton>
				}
				children={
					<>
						{serviceRequestEnabled && (
							<section className="ChildSection motif-body1-default-light">
								<MotifTextLink
									href={`${configurations?.features?.serviceGatewayBase}?engagementId=${engagement.engagementId}`}
									target={'_blank'}
									onClick={() => {
										setGateWayOptionsOpen(!gateWayOptionsOpen);
										setSelectedIcon(undefined);
									}}
									className="motif-body1-default-light"
								>
									<MotifIcon src={IconoirCustomServiceGateway} size="20" />
									<span className="SpanLableTxt">{labels.eyServiceGateway}</span>
								</MotifTextLink>
							</section>
						)}
						<section className="ChildSection motif-body1-default-light">
							<MotifTextLink
								href={Utility.getAutomationHubLink(baseCanvasUrl, engagement, engagements, isAutomationHubEnabled)}
								target={'_blank'}
								onClick={() => {
									setGateWayOptionsOpen(!gateWayOptionsOpen);
									setSelectedIcon(undefined);
								}}
								className="motif-body1-default-light"
							>
								<MotifIcon src={IconoirCustomSmartAutomationProduct} size="20" />
								<span className="SpanLableTxt">{labels.eyAutomation}</span>
							</MotifTextLink>
						</section>
					</>
				}
			/>
		);
	};

	const pushMaps = () => {
		return {
			key: 'maps',
			className: 'maps',
			title: labels.maps,
			url: env.getURL('hercules_web') + '/dashboard/maps?engagementId=' + engagement.engagementId + '&deepLink=true',
			children: (
				<a
					href={
						env.getURL('hercules_web') + '/dashboard/maps?engagementId=' + engagement.engagementId + '&deepLink=true'
					}
				>
					<MotifButton
						aria-label="Click to go to maps"
						type="button"
						variant="ghost"
						size="medium"
						title={labels.maps}
						onClick={() => {
							window.open(
								env.getURL('hercules_web') +
									'/dashboard/maps?engagementId=' +
									engagement.engagementId +
									'&deepLink=true',
								'_self'
							);
						}}
						className="motif-button-icon-only"
					>
						<MotifIcon src={IconoirMap} size="24" title={labels.maps} />
					</MotifButton>
				</a>
			)
		};
	};

	const pushFinancialStatements = () => {
		return {
			key: 'financialStatements',
			className: 'financialStatements',
			title: labels.financialStatements,
			url: env.getURL('hercules_web') + '/financialstatements?engagementId=' + engagement.engagementId,
			children: (
				<a href={env.getURL('hercules_web') + '/financialstatements?engagementId=' + engagement.engagementId}>
					<MotifButton
						aria-label="Click to go to financialstatements"
						type="button"
						variant="ghost"
						size="medium"
						title={labels.financialStatements}
						onClick={() => {
							window.open(
								env.getURL('hercules_web') + '/financialstatements?engagementId=' + engagement.engagementId,
								'_self'
							);
						}}
						className="motif-button-icon-only"
					>
						<MotifIcon src={IconoirReportColumns} size="24" title={labels.financialStatements} />
					</MotifButton>
				</a>
			)
		};
	};

	const baseCanvasUrl = Utility.getCanvasBaseUrl(engagement, displayLanguage);
	const serviceRequestEnabled =
		!_.isEmpty(configurations?.features?.serviceGatewayBase) &&
		!getSDMFeatureRestricted(
			configurations?.features?.restrictedCountryIdsForSDM,
			configurations?.features?.validServiceLinesForSDM,
			engagement?.countryId,
			engagement?.serviceLineId,
			engagement?.subServiceLineId
		);

	if (!engagementArchived && !engagementClosed) {
		menuOptions = [
			[
				{
					key: 'LandingPage',
					className: 'LandingPage',
					title: labels.navDashboard,
					url:
						env.getURL('hercules_web') +
						'/dashboard?engagementId=' +
						engagement.engagementId +
						'&deepLink=true#myProgress',
					children: (
						<a
							href={
								env.getURL('hercules_web') +
								'/dashboard?engagementId=' +
								engagement.engagementId +
								'&deepLink=true#myProgress'
							}
						>
							<MotifButton
								aria-label="Click to go to dashboard"
								type="button"
								variant="ghost"
								size="medium"
								title={labels.navDashboard}
								onClick={() => {
									window.open(
										env.getURL('hercules_web') +
											'/dashboard?engagementId=' +
											engagement.engagementId +
											'&deepLink=true#myProgress',
										'_self'
									);
								}}
								className="motif-button-icon-only"
							>
								<MotifIcon src={IconoirHome} size="24" title={labels.navDashboard} />
							</MotifButton>
						</a>
					)
				}
			],
			[
				{
					key: 'TaskPage',
					className: 'TaskPage',
					title: labels.tasksPage,
					url: env.getURL('hercules_web') + '/tasks?engagementId=' + engagement.engagementId,
					children: (
						<a href={env.getURL('hercules_web') + '/tasks?engagementId=' + engagement.engagementId}>
							<MotifButton
								aria-label="Click to go to tasks"
								type="button"
								variant="ghost"
								size="medium"
								title={labels.tasksPage}
								onClick={() => {
									window.open(env.getURL('hercules_web') + '/tasks?engagementId=' + engagement.engagementId, '_self');
								}}
								className="motif-button-icon-only"
							>
								<MotifIcon src={IconoirCustomTaskList} size="24" title={labels.tasksPage} />
							</MotifButton>
						</a>
					)
				},
				{
					key: 'DocumentsPage',
					className: 'DocumentsPage',
					title: labels.documentsPage,
					url:
						env.getURL('hercules_web') +
						'/dashboard?category=documents&engagementId=' +
						engagement.engagementId +
						'#engagementOverview',
					children: (
						<a
							href={
								env.getURL('hercules_web') +
								'/dashboard?category=documents&engagementId=' +
								engagement.engagementId +
								'#engagementOverview'
							}
						>
							<MotifButton
								aria-label="Click to go to documents"
								type="button"
								variant="ghost"
								size="medium"
								title={labels.documentsPage}
								onClick={() => {
									window.open(
										env.getURL('hercules_web') +
											'/dashboard?category=documents&engagementId=' +
											engagement.engagementId +
											'#engagementOverview',
										'_self'
									);
								}}
								className="motif-button-icon-only"
							>
								<MotifIcon src={IconoirPage} size="24" title={labels.documentsPage} />
							</MotifButton>
						</a>
					)
				},
				{
					key: 'ReviewNotesPage',
					className: 'ReviewNotesPage',
					url: env.getURL('hercules_web') + reviewNoteRoutes.reviewNoteHub + '?engagementid=' + engagement.engagementId,
					title: labels.navReviewNotes,
					children: (
						<a
							href={
								env.getURL('hercules_web') + reviewNoteRoutes.reviewNoteHub + '?engagementid=' + engagement.engagementId
							}
						>
							<MotifButton
								aria-label="Click to go to review notes"
								type="button"
								variant="ghost"
								size="medium"
								title={labels.navReviewNotes}
								onClick={() => {
									window.open(
										env.getURL('hercules_web') +
											reviewNoteRoutes.reviewNoteHub +
											'?engagementid=' +
											engagement.engagementId,
										'_self'
									);
								}}
								className="motif-button-icon-only"
							>
								<MotifIcon src={IconoirPageEdit} size="24" title={labels.navReviewNotes} />
							</MotifButton>
						</a>
					)
				},
				{
					key: 'CollaborationPage',
					className: 'CollaborationPage',
					url: env.getURL('hercules_web') + '/collaboration?engagementId=' + engagement.engagementId,
					title: labels.collaborationPage,
					children: (
						<a href={env.getURL('hercules_web') + '/collaboration?engagementId=' + engagement.engagementId}>
							<MotifButton
								aria-label="Click to go to collaboration"
								type="button"
								variant="ghost"
								size="medium"
								title={labels.collaborationPage}
								onClick={() => {
									window.open(
										env.getURL('hercules_web') + '/collaboration?engagementId=' + engagement.engagementId,
										'_self'
									);
								}}
								className="motif-button-icon-only"
							>
								<MotifIcon src={IconoirGroup} size="24" title={labels.collaborationPage} />
							</MotifButton>
						</a>
					)
				},
				serviceRequestEnabled && {
					key: 'ServiceGatewayAutomation',
					title: labels.serviceGatewayAutomation,
					children: getServiceGatewayAndAutomation()
				}
			]
		];
	}

	if (quickLinks?.defaultEngagementMapId) {
		if (menuOptions.length > 0 && Array.isArray(menuOptions[0])) {
			menuOptions[0].push(pushMaps());
		} else {
			menuOptions.push(pushMaps());
		}
	}

	if (quickLinks?.defaultTrialBalanceId !== null || engagement?.isHelixDataImportAllowed === true) {
		if (menuOptions.length > 0 && Array.isArray(menuOptions[0])) {
			menuOptions[0].push(pushFinancialStatements());
		} else {
			menuOptions.push(pushFinancialStatements());
		}
	}

	return menuOptions;
}
